import { oeffnenArt } from "../../documents/documentKind";

/**
 * Reine Ableitungen der Vorschau beim Überfahren (PO 30.08.2026). DOM-frei,
 * damit der node-only Vitest-Runner sie prüft.
 */

/**
 * Was lässt sich in einer kleinen Karte zeigen?
 *  - `bild`  — direkt als `<img>` (der Browser kann es);
 *  - `pdf`   — die erste Seite, gerendert;
 *  - `text`  — die ersten Zeilen;
 *  - `keine` — docx, xlsx, zip …: es gibt nichts zu zeigen, die Karte nennt
 *    stattdessen Typ, Größe und Datum. Eine leere Fläche wäre schlimmer als
 *    keine Vorschau, weil sie wie ein Ladefehler aussieht.
 */
export type VorschauArt = "bild" | "pdf" | "text" | "keine";

export function vorschauArt(fileName: string, mimeType?: string | null): VorschauArt {
    // Dieselbe Weiche wie beim Öffnen — ein Bild wird nie als PDF gerendert.
    const art = oeffnenArt(fileName, mimeType);
    if (art === "bild" || art === "pdf" || art === "text") return art;
    return "keine";
}

/** Dateigröße in deutscher Schreibweise („1,2 MB"); leer, wenn unbekannt. */
export function dateiGroesse(bytes?: number | null): string {
    if (bytes == null || !Number.isFinite(bytes) || bytes < 0) return "";
    if (bytes < 1024) return `${bytes} B`;
    const einheiten = ["KB", "MB", "GB", "TB"];
    let wert = bytes / 1024;
    let i = 0;
    while (wert >= 1024 && i < einheiten.length - 1) {
        wert /= 1024;
        i += 1;
    }
    const gerundet = wert >= 100 ? Math.round(wert) : Math.round(wert * 10) / 10;
    return `${String(gerundet).replace(".", ",")} ${einheiten[i]}`;
}

/** Kurzform des Dateityps für die Infokarte („DOCX", sonst der MIME-Typ). */
export function typKurz(fileName: string, mimeType?: string | null): string {
    const punkt = fileName.lastIndexOf(".");
    const ext = punkt >= 0 && punkt < fileName.length - 1 ? fileName.slice(punkt + 1) : "";
    if (ext) return ext.toUpperCase();
    return (mimeType ?? "").split(";")[0] || "Datei";
}

/**
 * Textausschnitt für die Mail-Vorschau: der Snapshot des MailLink führt oft
 * einen zusammengelaufenen Einzeiler mit sich. Auf `max` Zeichen gekürzt.
 */
export function mailAusschnitt(preview?: string | null, max = 400): string {
    const text = String(preview ?? "")
        .replace(/\r/g, "")
        .replace(/[ \t]+/g, " ")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    return text.length > max ? `${text.slice(0, max - 1)}…` : text;
}
